import { doNotModifyCodeBelow } from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson0DefaultMiddleCode = `
// TODO: add the Starknet file specifier at the beginning of the file
`;

export const lesson0DefaultEndCode = `${doNotModifyCodeBelow}
// All Starknet files must start with a specific line indicating the file is a smart contract,
// not just a regular Cairo file
func add(x: felt, y: felt) -> (res: felt) {
    return (res=x + y);
}

@view
func test_add() {
    add(1, 2);
    return();
}`;
